import { Swiper } from 'swiper/bundle';

export default class Slider {
    constructor() {
        this.init();
    }

    init() {

        // --- HOME-HEADER-SWIPER ---
        const swiperHomeHeaderContent = new Swiper(".swiper-home-header-content", {
            loop: true,
            effect: "fade",
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".swiper-home-header-content .swiper-next",
                prevEl: ".swiper-home-header-content .swiper-prev",
            },
        });
        const swiperHomeHeaderImg = new Swiper(".swiper-home-header-img", {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            spaceBetween: 12,
            grabCursor: false,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
            on: {
                slideChangeTransitionStart: function() {
                    var slides = document.querySelectorAll('.swiper-home-header-img .swiper-slide');
                    slides.forEach(function(slide) {
                        slide.style.opacity = 0.4;
                    });
                },
                slideChangeTransitionEnd: function() {
                    var activeSlide = document.querySelector('.swiper-home-header-img .swiper-slide-active');
                    activeSlide.style.opacity = 1;
                },
            },
            thumbs: {
                swiper: swiperHomeHeaderContent,
            },
            navigation: {
                nextEl: ".swiper-home-header-content .swiper-next",
                prevEl: ".swiper-home-header-content .swiper-prev",
            },
        });



        // --- CTA-POSTS-SWIPER ---
        const ctaPostsSwiper = new Swiper(".cta-posts-swiper", {
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 36,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 48,
                },
            },
            observer: true,
            observeParents: true,
            // navigation: {
            //     nextEl: ".cta-posts-swiper .swiper-next",
            //     prevEl: ".cta-posts-swiper .swiper-prev",
            // },
        });


        // --- SAME-CAT-POSTS-SWIPER ---
        const sameCatPostsSwiper = new Swiper(".same-cat-posts-swiper", {
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
            navigation: {
                nextEl: ".col-same-cat-posts .swiper-navigation .swiper-next",
                prevEl: ".col-same-cat-posts .swiper-navigation .swiper-prev",
            },
        });


        // --- SWIPER-MISSIONS ---
        const missionsSwiper = new Swiper(".swiper-missions", {
            loop: true,
            speed: 1000,
            effect: "creative",
            grabCursor: false,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
        });

        const accordions = document.querySelectorAll('.col-missions .accordion-collapse');

        accordions.forEach((accordion, index) => {
            accordion.addEventListener('shown.bs.collapse', function () {
                missionsSwiper.slideTo(index);
            });
        });

    }
}

